import { match } from "ts-pattern";
import { Booking } from "../../../types/bookings";

export type LeaseCategory = "booking" | "lease" | "renewal";

type MatchInput = { leaseType?: string; isActiveLease: boolean; isActiveRenewal: boolean };
type MatchOutput = LeaseCategory | null;

const ACTIVE_LEASE_STATUSES = new Set(["active", "active_renewing", "active_vacating"]);
const ACTIVE_RENEWAL_STATUSES = new Set(["active"]);

export const getLeaseCategory = (bookingDetails?: Booking): LeaseCategory | null => {
  if (!bookingDetails) return null;

  const { leaseType, leaseStatus, renewalStatus } = bookingDetails;
  const isActiveLease = Boolean(leaseStatus) && ACTIVE_LEASE_STATUSES.has(leaseStatus);
  const isActiveRenewal = Boolean(renewalStatus) && ACTIVE_RENEWAL_STATUSES.has(renewalStatus);

  return match<MatchInput, MatchOutput>({ leaseType, isActiveLease, isActiveRenewal })
    .with({ leaseType: "new", isActiveLease: true }, () => "lease")
    .with({ leaseType: "new", isActiveLease: false }, () => "booking")
    .with({ leaseType: "renewal", isActiveLease: false, isActiveRenewal: false }, () => "renewal")
    .otherwise(() => null);
};
